import { useRef } from "react";
import { ApplicationPaths } from "./AuthConstants";
import Cookies from 'js-cookie';
import useEventListeners from "@arelia-hooks/useEventListeners";

export default function LogoutForm({ children }: any) {
  const formRef = useRef<HTMLFormElement>(null);

  useEventListeners(["formdata"], (ev: any) => {
    ev.formData.set("__RequestVerificationToken", Cookies.get("API-CSRF-TOKEN"));
  }, formRef);

  return (
    <form ref={formRef} method="post" action={ApplicationPaths.LogOut}>
      {children}
    </form>
  );
}